import { render, staticRenderFns } from "./FormCore.vue?vue&type=template&id=d204b01e&scoped=true"
import script from "./FormCore.vue?vue&type=script&lang=ts"
export * from "./FormCore.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../web-ai-translation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d204b01e",
  null
  
)

export default component.exports